<template>
<form>
<ul>
    <li class="facet OTfacet" v-for="dimension in facet.dimensions">
        <div class="fieldContainer form-group OTformgroupsingle">
            <input type="radio" class="OTradio" :id="'facet-' + slugify(dimension.id)" :name="facet.id" :value="dimension.id" v-on:click="selectFacet(dimension)" :checked="isSelected(dimension.id)">
            <label class="OTradio" :for="'facet-' + slugify(dimension.id)"><span class="OTicon-radio"></span> {{ dimension.label }} </label>
        </div>
    </li>
</ul>
</form>
</template>
<script>

import {slugify} from '../../utils.js';

export default {
    props: ['facet', 'value'],
    methods: {
        selectFacet(dimension) {
            this.$emit('input', [dimension.id]);
        },
        slugify(val) {
            return slugify(val);
        },

        isSelected(dimensionId) {
            if (!this.$store.state.facets.selectedFacets[this.facet.id]) {
                return false;
            }

            for (let i = 0; i < this.$store.state.facets.selectedFacets[this.facet.id].length; i++) {
                if (this.$store.state.facets.selectedFacets[this.facet.id][i] === dimensionId) {
                    return true;
                }
            }
            return false;
        }
    },

    computed: {
        selectedFacets() {
            return this.$store.state.facets.selectedFacets;
        }
    }
}

</script>
